module.exports = __webpack_public_path__ + "static/img/3.6f7a4e7f.png";